export default __webpack_public_path__ + "static/media/Ballroll_00272.b71a3e92.png";